import { requestCallCenter, unwrapEnvelopeValue } from "./CallCenterApi";

const BASE = "account-plan-types";

export const listAccountPlanTypes = async (params = {}) => {
  const envelope = await requestCallCenter({
    method: "get",
    url: BASE,
    params,
  });
  return unwrapEnvelopeValue(envelope, "Failed to list plan templates");
};

export const getAccountPlanType = async (planTypeId) => {
  const envelope = await requestCallCenter({
    method: "get",
    url: `${BASE}/${planTypeId}`,
  });
  return unwrapEnvelopeValue(envelope, "Failed to fetch plan template");
};

export const createAccountPlanType = async (payload) => {
  const envelope = await requestCallCenter({
    method: "post",
    url: BASE,
    data: payload,
  });
  return unwrapEnvelopeValue(envelope, "Failed to create plan template");
};

export const updateAccountPlanType = async (planTypeId, payload) => {
  const envelope = await requestCallCenter({
    method: "put",
    url: `${BASE}/${planTypeId}`,
    data: payload,
  });
  return unwrapEnvelopeValue(envelope, "Failed to update plan template");
};
